export const environment = {
    production: true,
    firebase: {
        apiKey: "AIzaSyD3D0mY12PWvYD7AiyFIA59CPn89VLJBqc",
        authDomain: "vetancid-es-andina.firebaseapp.com",
        projectId: "vetancid-es-andina",
        storageBucket: "vetancid-es-andina.appspot.com",
        messagingSenderId: "630771255639",
        appId: "1:630771255639:web:c693cf8a324dfc2e349612"
    }
};